'use client';

import { CustomButton } from '@/components/ui/custom-button';
import { Link } from "@/i18n/navigation";

export default function NotFound() {  
  return (
    <div className="absolute top-0 flex h-dvh w-full flex-col items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-8xl font-bold tracking-tight text-gray-900 dark:text-gray-50">
          404
        </h1>

        <p className="mt-4 text-lg font-medium dark:text-gray-400">
          Oops, the page you are looking for does not exist.
        </p>

        <Link href="/app">
          <CustomButton variant="primary" size="lg" className="mx-auto mt-6">
            Go back home
          </CustomButton>
        </Link>
      </div>
    </div>
  );
}
